import logo from './logo.svg';
import './App.css';
import Homepage from './Homepage';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Contact from './Contactpage';
import Aboutpage from './Aboutpage';
import TestimonialFilter from './TestimonialFilter';
import OfferPageEdit from './OfferPageEdit';
import ServiceEditPage from './ServiceEditPage';
import GalleryEditPage from './GalleryEditPage';
import ServiceEditPage1 from './ServiceEditPage1';
import ServicePageSingle from './ServicePageSingle';
import SocialMediaLinksPage from './SMLinksaddPage';
import AuthForm from './Signin';
import Profile from './Profile';
import SEO from './SEO';
import ServicePage from './ServicePage';
import GalleryPage from './GalleryPage';
import PersonFormPage from './PersonFormPage';
import AttendanceFormPage from './AttendaceFormPage';
import PaymentFormPage from './PaymentFormPage';
import DashboardPage from './DashboardPage';
import DashboardPage1 from './DashboardPage1';
import DemoPage from './DemoPage';
import Loader from './Components/Loader';
import ScrollToTop from './Components/Scrollpage';


const App=()=>{
  return (
    <BrowserRouter>
    <Loader/>
    <ScrollToTop/>
      <Routes>
        <Route path="/" element={<Homepage/>}/>
        <Route path="/contact" element={<Contact/>}/>
        <Route path="/about" element={<Aboutpage/>}/>
        <Route path="/auth" element={<AuthForm/>}/>
        <Route path="/testimonialfilter" element={<TestimonialFilter/>}/>
        {/* <Route path="/offeredit" element={<OfferPageEdit/>}/> */}
        {/* <Route path="/workedit" element={<ServiceEditPage/>}/> */}
        <Route path="/galleryedit" element={<GalleryEditPage/>}/>
        <Route path="/serviceedit" element={<ServiceEditPage1/>}/>
        {/* <Route path="/services/:title" element={<ServicePageSingle/>}/> */}
        <Route path="/sociallinks" element={<SocialMediaLinksPage/>}/>
        <Route path="/profile" element={<Profile/>}/>
        <Route path="/seo" element={<SEO/>}/>
        <Route path="/service/:title" element={<ServicePage/>}/>
        <Route path="/gallery" element={<GalleryPage/>}/>
        <Route path="/newperson" element={<PersonFormPage/>}/>
        <Route path="/attendanceform" element={<AttendanceFormPage/>}/>
        <Route path="/paymentform" element={<PaymentFormPage/>}/>
        <Route path="/Attendancedashboard" element={<DashboardPage/>}/>
        <Route path="/paymentdashboard" element={<DashboardPage1/>}/>
        <Route path="/demo" element={<DemoPage/>}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
